// src/data/travelArticles.js
const travelArticles = [
    {
        url: "https://ktxmagazine.kr/%ed%95%9c%ec%97%ac%eb%a6%84%ec%9d%98-%ed%95%98%eb%aa%a8%eb%8b%88-%ec%9a%b8%ec%82%b0-%eb%82%a8%ea%b5%ac/",
        title: "한여름의 하모니, 울산 남구 여행",
        thumbnail: "gs://gabojago-67419.firebasestorage.app/articles/ulsan_article.png"
    },
    {
        url: "https://ktxmagazine.kr/%eb%ac%bc%ea%b8%b8-%eb%94%b0%eb%9d%bc-%ed%9d%90%eb%a5%b4%eb%8a%94-%eb%a7%88%ec%9d%8c-%ec%95%88%eb%8f%99/",
        title: "물길 따라 흐르는 마음, 안동 여행",
        thumbnail: "gs://gabojago-67419.firebasestorage.app/articles/andong_article.png"
    },
    {
        url: "https://ktxmagazine.kr/%ea%b0%95%eb%a6%89%ec%97%90%ec%84%9c-%ea%b0%90%ec%84%b1-%ec%b6%a9%ec%a0%84/",
        title: "강릉에서 감성 충전, 여름 여행",
        thumbnail: "gs://gabojago-67419.firebasestorage.app/articles/gangneung_article.png"
    },
    {
        url: "https://www.travie.com/news/articleView.html?idxno=54571",
        title: "소청도의 청정 매력을 만나는 여행",
        thumbnail: "gs://gabojago-67419.firebasestorage.app/articles/socheongdo_article.png"
    },
    {
        url: "https://www.travie.com/news/articleView.html?idxno=54279",
        title: "속초, 동해의 숨은 보석 같은 여행지",
        thumbnail: "gs://gabojago-67419.firebasestorage.app/articles/sokcho_article.png"
    },
    {
        url: "https://www.travie.com/news/articleView.html?idxno=54278",
        title: "김천, 자연과 역사 속으로 떠나는 여행",
        thumbnail: "gs://gabojago-67419.firebasestorage.app/articles/gimcheon_article.png"
    },
    {
        url: "https://www.travie.com/news/articleView.html?idxno=54254",
        title: "철원, 평화의 숨결이 느껴지는 여행",
        thumbnail: "gs://gabojago-67419.firebasestorage.app/articles/cheolwon_article.png"
    },
    {
        url: "https://korean.visitkorea.or.kr/detail/rem_detail.do?cotid=45a19937-2d68-456e-8c2e-dd46c9400269",
        title: "단양, 절경 속 힐링 여행",
        thumbnail: "gs://gabojago-67419.firebasestorage.app/articles/danyang_article.png"
    }
];

export default travelArticles;
